/* eslint-disable */
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './styles/search-form.scss';

class SearchForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchTerm: '',
            showTaxons: false,
            // taxonSelected: 'all',
            // taxonSelectedName: 'All',
        };

        this.searchInput = React.createRef();

        this.submitSearchForm = this.submitSearchForm.bind(this);
        this.onSearchInputChange = this.onSearchInputChange.bind(this);
        this.onClear = this.onClear.bind(this);

        this.toggleTaxons = this.toggleTaxons.bind(this);
    }

    onSearchInputChange(event) {
        this.setState({ searchTerm: event.target.value });
    }

    submitSearchForm(event) {
        event.preventDefault();
        this.props.submitSearchForm(this.state.searchTerm, this.props.locale.currentLocale);
    }

    toggleTaxons() {
        this.setState((prevState) => ({ showTaxons: !prevState.showTaxons }));
    }

    selectTaxon(e) {
        // this.setState({ taxonSelected: e.target.id, taxonSelectedName: e.target.getAttribute('aria-label') });
        this.toggleTaxons();
    }

    onClear() {
        if(this.state.searchTerm && this.state.searchTerm.length > 0) {
            this.setState({ searchTerm: '' });
            this.searchInput.current.focus();
        }
    }

    render() {
        // const taxonList = this.props.filterTaxons(this.props.taxons).map((taxon) => (
        //     <li
        //         key={taxon.id}
        //         className={`${this.state.taxonSelected === taxon.attributes.permalink ? styles.activeResultOption : ''} ${styles.selectResultOption}`}
        //         onClick={(e) => this.selectTaxon(e)}
        //     >
        //         <div id={taxon.attributes.permalink} aria-label={taxon.attributes.name} className={taxon.attributes.depth === 0 ? styles.level0 : styles.level1}>
        //             {taxon.attributes.name}
        //         </div>
        //     </li>
        // ));

        return (
            <form onSubmit={this.submitSearchForm} className={styles.navbarSearch}>
                <div className={`form-group input-group ${styles.formGroup}`}>
                    {/* <span className={`input-group-btn hidden-xs ${styles.inputGroup}`}> */}
                    {/*    <span className={`select ${styles.inputSelect}`}> */}
                    {/*        <span className={`select ${styles.inputSelector}`} onClick={this.toggleTaxons}> */}
                    {/*            <span className="selection"> */}
                    {/*                <span className={`${styles.currentSelection}`}> */}
                    {/*                    <span */}
                    {/*                        className={`${styles.currentSelectionRender}`} */}
                    {/*                        id="select2-search-container" */}
                    {/*                        title={<FormattedMessage id="all" defaultMessage="All" />} */}
                    {/*                    > */}
                    {/*                        {this.state.taxonSelected === 'all' ? <FormattedMessage id="all" defaultMessage="All" /> : this.state.taxonSelectedName} */}
                    {/*                    </span> */}
                    {/*                    <span className={`${styles.selectionArrow}`}> */}
                    {/*                        <b /> */}
                    {/*                    </span> */}
                    {/*                </span> */}
                    {/*            </span> */}
                    {/*            <span className="dropdown-wrapper" /> */}
                    {/*        </span> */}
                    {/*        <span className={`${styles.selectContainer}`} style={{ display: this.state.showTaxons ? 'block' : 'none' }}> */}
                    {/*            <span className={`${styles.selectDropdown}`}> */}
                    {/*                <span className={`${styles.selectResults}`}> */}
                    {/*                    <ul className={`${styles.selectResultsOptions}`}> */}
                    {/*                        <li */}
                    {/*                            className={`${this.state.taxonSelected === 'all' ? styles.activeResultOption : ''} ${styles.selectResultOption}`} */}
                    {/*                            onClick={(e) => this.selectTaxon(e)} */}
                    {/*                        > */}
                    {/*                            <div id="all" value="All" className={styles.level0}> */}
                    {/*                                <FormattedMessage id="all" defaultMessage="All" /> */}
                    {/*                            </div> */}
                    {/*                        </li> */}
                    {/*                        /!* {taxonList} *!/ */}
                    {/*                    </ul> */}
                    {/*                </span> */}
                    {/*            </span> */}
                    {/*        </span> */}
                    {/*    </span> */}
                    {/* </span> */}
                    <span className={`input-group-btn ${styles.inputGroupButton}`}>
                        <button type="submit" className={`btn icon-btn ${styles.inputButton}`}>
                            <i className={`pe-7s-search pe-lg ${styles.headerSearchIcon}`} />
                        </button>
                    </span>
                    <input
                        type="text"
                        className={`form-control ${styles.headerSearchInput}`}
                        onChange={this.onSearchInputChange}
                        placeholder=""
                        defaultValue={this.props.searchTerm}
                        id="search-input-box"
                        value={this.state.searchTerm}
                        ref={this.searchInput}
                    />
                    <span onClick={this.onClear} className={`${styles.closeIcon} ${this.state.searchTerm && this.state.searchTerm.length > 0 ? styles.closeIconEnabled: styles.closeIconDisabled}`} title="Clear">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" />
                        </svg>
                    </span>
                </div>
            </form>
        );
    }
}

export default SearchForm;



/** WEBPACK FOOTER **
 ** ./src/components/shared/header/search-form.jsx
 **/